module.exports = __webpack_public_path__ + "img/app_korat_4.694ec1f6.jpg";